<template>
  <div class="page-wrapper">
    <div class="legal-page">
      <h2 class="page-title">Mentions légales</h2>

      <h3>Éditeur du site</h3>
      <p>
        <strong>Propriétaire et Directeur de la publication :</strong> Bondue Christophe<br>
        <strong>Email :</strong> contact@elpulpo.xyz
      </p>

      <h3>Hébergement</h3>
      <p>
        Le site est hébergé par <strong>Hostinger</strong> sur un serveur installé à Paris.<br>
        <strong>Adresse :</strong> 61 Lordou Vironos Street, 6023 Larnaca, Chypre<br>
        <strong>Site :</strong> www.hostinger.fr
      </p>

      <h3>Propriété intellectuelle</h3>
      <p>
        Tous les contenus présents sur ce site (textes, images, logos) sont la propriété exclusive du propriétaire, sauf
        mention contraire. DartsHub est un service centralisé d'authentification et de gestion
        des licences développé par et pour la communauté fléchettes.
      </p>

      <h3>Responsabilité</h3>
      <p>
        Le propriétaire du site s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées
        sur le site. Toutefois, il ne saurait être tenu responsable des erreurs ou omissions.
      </p>
    </div>

    <Footer backLink />
  </div>
</template>

<script setup lang="ts">
import Footer from '@/components/Footer.vue';
</script>

<style scoped>
.page-wrapper { min-height: 100svh; display: flex; flex-direction: column; }

.legal-page {
  flex: 1;
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: var(--bg-card);
  border-radius: var(--radius);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
}

h2 { margin-bottom: 1.5rem; }
h3 { margin-top: 1.5rem; margin-bottom: 0.5rem; }
p  { line-height: 1.7; }

</style>
